<template>
  <div>
    <div v-if="!isValidSystemSetup" class="error--text">{{ errorMessage }}</div>
    <div v-else>
      <v-btn
          class="white__v-btn mb-2"
          :loading="downloadingPrint"
          @click="downloadPrint(fileUuid, 'downloadingPrint','Печать введенных данных этап 3.pdf','application/pdf', `?idCo=${6}`)"
      >
        скачать
      </v-btn>
      <PDFViewer
          v-if="fileBase64"
          :source="fileBase64"
          rendering-text="Идет отрисовка"
          loading-text="Нажмите кнопку скачать"
          style="height: 70vh; width: 100%;"
          :controls="['download', 'print', 'zoom', 'rotate']"
          @download="savePdfFile"
      />
<!--      <VuePdfEmbed-->
<!--          v-if="fileBase64"-->
<!--          :source="fileBase64"-->
<!--          style="height: 70vh; width:90%"-->
<!--          @download="savePdfFile"-->
<!--      />-->
      <!-- style="height: 100vh; width: 100vw"     -->
      <v-autocomplete
          v-model="chosenCertificate"
          :items="certificates"
          label="Выберите..."
          no-data-text="Нет доступных сертификатов"
          dense
          class="mt-2"
          clearable
          outlined
      ></v-autocomplete>
      <!--      <v-file-input-->
      <!--          label="Выбрать файл pdf..."-->
      <!--          v-model="file"-->
      <!--          :rules="rules"-->
      <!--          accept="application/pdf"-->
      <!--      />-->
      <v-btn class="blue__v-btn" :disabled="!validate" :loading="signingFile" @click="signFile">
        Подписать
      </v-btn>
    </div>
  </div>
</template>

<script>
import {getUserCertificates, isValidSystemSetup, createDetachedSignature, createHash} from 'crypto-pro';
import {mapActions} from "vuex";
import {setFileFunctions} from "@/mixins/fileFucntions";
import axios from "axios";
import {calcDateNow} from "@/utils/date";
import VuePdfViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'
// import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import {saveBlobFile, saveFile} from "@/utils/saveFile";
//examples CryptoCode https://codesandbox.io/s/crypto-pro-example-es5-script-tag-797gr?file=/public/create-sign.js:1498-1511
export default {
  name: "CryptoTest",
  mixins: [setFileFunctions],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    PDFViewer: VuePdfViewer,
  },
  data() {
    return {
      isValidSystemSetup: false,
      signingFile: false,
      validate: false,
      downloadingPrint: false,
      errorMessage: 'Нет доступа к плагину CryptoPro',
      certificates: [],
      chosenCertificate: null,
      hash: null,
      signature: null,
      fileUuid: 'PrintStage3',
      file: null,
      fileBase64: null,
      fileArrayBuffer: null,
      rules: [
        value => !value || value.size < 25428800 || 'Размер файла не должен превышать 25 МБ!',
        value => !value || value.type === 'application/pdf' || 'Допустимы файлы только в pdf формате',
        value => {
          if (!value) {
            this.validate = null;
            return false;
          } else if (value.type === 'application/pdf') {
            this.validate = true;
            return true;
          } else {
            this.validate = false;
            return false;
          }
        }
      ]
    }
  },
  created() {
    this.checkSystem()
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    checkSystem() {
      isValidSystemSetup()
          .then(isValidSystemSetup => {
            this.isValidSystemSetup = isValidSystemSetup;
            console.log('valid: ', isValidSystemSetup);
            if (isValidSystemSetup) {
              this.getCertificates()
            }
          })
          .catch((e) => {
                this.isValidSystemSetup = false;
                console.error(e)
                this.errorMessage = e.message;
                this.addNotification({
                  notificationStatus: "error",
                  notificationTime: 10000,
                  notificationMessage: e.message
                })
              }
          )
    },
    getCertificates() {
      getUserCertificates().then(async certificates => {
        console.log('certificates', certificates);
        this.certificates = (await Promise.all(certificates.map(async (el) => {
              let isValid;
              const res = await el._cadesCertificate?.IsValid();
              isValid = await res.Result;
              return {value: el.thumbprint, text: el.name, isValid: isValid};
            })
        )).filter(el => el.isValid)
      }).catch((error) => {
        this.errorMessage = error.message;
        console.error('getCertificates error', error.message)
      })
    },
    createSignature(uid = this.fileUuid, hash) {
      console.log('hash', hash)
      // eslint-disable-next-line no-unused-vars
      const msg = `${uid}-${calcDateNow()}`;
      createDetachedSignature(this.chosenCertificate, hash)
          .then(signature => {
            console.log('signature', signature);
            saveFile({
              fileBytes: signature,
              withoutEncode: false,
              fileName: `signature-${msg}`,
              fileFormat: '.sgn'
            })
          })
          .catch(e => this.addNotification({notificationMessage: e.message, notificationStatus: 'error'}))
    },
    signFile() {
      if (!this.chosenCertificate) {
        this.addNotification({notificationMessage: 'Выберите сертификат', notificationStatus: 'warning'})
        return;
      }
      if (!this.file) {
        this.addNotification({notificationMessage: 'Файл не загружен', notificationStatus: 'warning'})
        return;
      }
      this.signingFile = true;
      this.changeFileToArrayBuffer().then(arrBuf => {
        console.log('arrBuf', arrBuf)
        createHash(arrBuf)
            .then(msg => this.createSignature(this.fileUuid, msg))
            .finally(() => this.signingFile = false)
      })
    },
    savePdfFile() {
      saveBlobFile(this.file)
    },
    changeFileToArrayBuffer() {
      return new Promise((res) => {
        if (this.fileArrayBuffer)
          res(this.fileArrayBuffer);
        const reader = new FileReader();
        reader.readAsArrayBuffer(this.file);
        reader.onload = () => res(reader.result);
      })
    },
    changeBlobToBase64(data) {
      return new Promise((res) => {
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => res(reader.result);
      })
    },
    // eslint-disable-next-line
    async downloadBlobDocument(api = '', type = '"application/pdf"', nameFile) {
      this.downloadingFileForPrint = true;
      await axios.get(api, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer   ${this.getKeycloakData?.token}`
        },
      })
          .then(response => {
            this.changeBlobToBase64(response.data).then((base64) => this.fileBase64 = base64);
            this.validate = true
            this.file = response.data;
            const reader = new FileReader();
            reader.readAsArrayBuffer(response.data);
            reader.onload = () => this.fileArrayBuffer = reader.result;
          })
          .catch(e => console.error(e))
          .finally(() => this.downloadingFileForPrint = false);
    }
  },
}
</script>

<style lang="sass">
.pdf-viewer__header
  z-index: 7
</style>